module.exports = {
	"labs": {
		"title": "",
		"subtitle": "",
		"introcopy": "",
		"labSingles": [
			{
				"labID": "metagramme",
				"title": "Metagramme",
				"gridImg": "/images/home-workgrid/mtc-sq.jpg",
				"icon": "/images/metagramme-logo.png",
				"client": "Martian",
				"launch": "Oct 2014",
				"projectColor": "D94C02",
				"pageHero": {
					"mediaType": "video",
					"src": "/videos/metagramme_large.mp4",
					"poster": "/images/metagramme-hero-2.jpg",
					"copy": "Using image data to look at images differently.",
					"headerOverlayOpacity": ".2"
				},
				"pageContent": [
					{
						"type": "sectionHeader",
						"number": "01",
						"title": "Challenge"
					},
					{
						"type": "intro",
						"intro": "<p>We love exploring different ways to process and view images. We also love to explore and visualize data.</p><p>This concept stemmed from a sketchbook idea from a couple years prior.</p><p>We wanted to see if we could 'average' a set of images and come up with something cool. <br/>We hoped that the output would be both a mathematical average of the source images, as well as maintain some context with regard to image content & composition.</p>",
						"logo": "/images/metagramme-logo.png"
					},
					{
						"type": "image",
						"size": "full",
						"images": [
							{
								"title": "",
								"src": "/images/metagramme-full-1.png"
							}
						]
					},
					{
						"type": "sectionHeader",
						"number": "02",
						"title": "Solution"
					},
					{
						"type": "textColumns",
						"copyLeft": "<p>The application needed to work on any screen, so the UI was designed to work on both small and large screens.</p><p>The concept is abstract, so we wanted to simulate the process visually to help users understand what was happening.</p><p>The site was a hit, and was featured by Wired Magazine both on their site and their Instagram feed. The production server was run on AWS and was built to scale; it handled the Wired traffic flawlessly.</p>",
						"copyRight": "<p>This concept is awesome; theoretically you could visualize what society thinks \"sadness\" looks like.</p><p>We began with Instagram because it seemed to be a straightforward data source. However, Instagram has a ton of spam; \"#apple\" brings up free iPad spam etc. <br/>In the future, we hope to add other image sources like Flickr that are more curated.</p><p>We also plan to use higher-resolution images and allow users to print out the results.</p>"
					},
					{
						"type": "image",
						"size": "full",
						"images": [
							{
								"title": "",
								"src": "/images/metagramme-full-2.png"
							},
							{
								"title": "",
								"src": "/images/metagramme-full-3.png"
							},
							{
								"title": "",
								"src": "/images/metagramme-full-4.png"
							}
						]
					},
					{
						"type": "details",
						"siteurlLinkTitle": "Visit the Site",
						"siteurl": "https://metagram.me",
						"list1Title": "What We Did",
						"list1": [
							{
								"title": "Concepting"
							},
							{
								"title": "UX"
							},
							{
								"title": "Prototyping"
							},
							{
								"title": "Branding"
							},
							{
								"title": "UI Design"
							},
							{
								"title": "Front-end Development"
							},
							{
								"title": "Backend Development"
							}
						],
						"list2Title": "Technologies",
						"list2": [
							{
								"title": ""
							},
							{
								"title": ""
							},
							{
								"title": ""
							}
						]
					}
				]
			},
			{
				"labID": "twitter-fingerprint",
				"title": "Twitter Fingerprint",
				"gridImg": "/images/home-workgrid/mtc-sq.jpg",
				"icon": "/images/martian-logo.png",
				"client": "Martian",
				"launch": "Dec 2014",
				"projectColor": "D94C02",
				"pageHero": {
					"mediaType": "video",
					"src": "/videos/twitterfp_large.mp4",
					"poster": "/images/twfp-hero-1.jpg",
					"copy": "A rapid-fire, iterative data-visualization experiment",
					"headerOverlayOpacity": ".36"
				},
				"pageContent": [
					{
						"type": "sectionHeader",
						"number": "01",
						"title": "Challenge"
					},
					{
						"type": "intro",
						"intro": "<p>We found ourselves with some free time and decided to build something that we could iterate on and get to MVP within this block of time.</p><p>This was another project from the archives that we thought could use a little more love.</p><p>We were looking for data and usage patterns that could possibly be used as unique identifiers or fingerprints for each user.</p>",
						"logo": "/images/martian-logo.png"
					},
					{
						"type": "sectionHeader",
						"number": "02",
						"title": "Solution"
					},
					{
						"type": "textColumns",
						"copyLeft": "<p>We chose a data source that was A) ubuquitous and well-used and B) that had a robust API. Twitter fit that perfectly.</p><p>The project's interaction was basic enough to allow us to wireframe and design simultaneously. <br/>We began prototyping as soon as we had settled on the circular graphs.</p>",
						"copyRight": "<p>This is a perfect example of the agile, iterative process at work. This is how R&D should work. We built a functioning application, with plenty of room for additional features.</p><p>Conceptually, we think we're on to something. Developing a visual fingerprint for web usage can tell us a lot about a person (or bot).</p>"
					},
					{
						"type": "image",
						"size": "full",
						"images": [
							{
								"title": "",
								"src": "/images/twfp-full-1.png"
							},
							{
								"title": "",
								"src": "/images/twfp-full-2.jpg"
							}
						]
					},
					{
						"type": "details",
						"siteurlLinkTitle": "Visit the Site",
						"siteurl": "http://twitterfp.martiansf.com",
						"list1Title": "What We Did",
						"list1": [
							{
								"title": "Concepting"
							},
							{
								"title": "UX"
							},
							{
								"title": "Prototyping"
							},
							{
								"title": "Design"
							},
							{
								"title": "Front-end Development"
							},
							{
								"title": "Backend Development"
							}
						],
						"list2Title": "Technologies",
						"list2": [
							{
								"title": ""
							},
							{
								"title": ""
							},
							{
								"title": ""
							}
						]
					}
				]
			},
			{
				"labID": "scrum-poker",
				"title": "Scrum Poker",
				"gridImg": "/images/home-workgrid/mtc-sq.jpg",
				"icon": "/images/martian-logo.png",
				"client": "Martian",
				"launch": "July 2014",
				"projectColor": "D94C02",
				"pageHero": {
					"mediaType": "video",
					"src": "/videos/scrumpoker_large.mp4",
					"poster": "/images/scrumpoker-hero-1.jpg",
					"copy": "Making tools to simplify our internal workflow",
					"headerOverlayOpacity": ".6"
				},
				"pageContent": [
					{
						"type": "sectionHeader",
						"number": "01",
						"title": "Challenge"
					},
					{
						"type": "intro",
						"intro": "<p>Scrum Poker is a critical part of the Agile Development Process; estimating tasks happens in the Sprint planning phase.<br/>Unfortunately, there's no good standard way to do this.</p><p>Currently the standard practice is to have a literal deck of cards, or download an app that just displays a number on your phone to show the group.</p>",
						"logo": "/images/martian-logo.png"
					},
					{
						"type": "sectionHeader",
						"number": "02",
						"title": "Solution"
					},
					{
						"type": "textColumns",
						"copyLeft": "<p>The biggest pain-points are actually tallying the votes up manually, doing so without influencing others, and working with a distributed team.</p><p>We were messing around with sockets and the concept of real-time peer connection, and came up with an awesome solution.</p><p>This was a no-brainer in terms of requirements; this was a simple solution to a very tedious part of the Agile process.</p>",
						"copyRight": "<p>The app allows multiple tables, anonymous voting, and a dealer-override button. Offsite team members' votes are identical to those attending in-person.</p><p>In addition to your own vote, the results screen shows the mean, the mode, the lowest and highest votes, as well as the table ID and the dealer name.</p><p>This tool simplifies the sprint planning process and saves a ton of time in the process.</p>"
					},
					{
						"type": "image",
						"size": "full",
						"images": [
							{
								"title": "Image title",
								"src": "/images/scrumpoker-full-1.png"
							},
							{
								"title": "Image title",
								"src": "/images/scrumpoker-full-2.png"
							},
							{
								"title": "Image title",
								"src": "/images/scrumpoker-full-3.png"
							}
						]
					},
					{
						"type": "details",
						"siteurlLinkTitle": "Visit the Site",
						"siteurl": "http://scrumpoker.martiansf.com",
						"list1Title": "What We Did",
						"list1": [
							{
								"title": "Concepting"
							},
							{
								"title": "UX"
							},
							{
								"title": "Prototyping"
							},
							{
								"title": "Design"
							},
							{
								"title": "Front-end Development"
							},
							{
								"title": "Backend Development"
							}
						],
						"list2Title": "Technologies",
						"list2": [
							{
								"title": ""
							},
							{
								"title": ""
							},
							{
								"title": ""
							}
						]
					}
				]
			},
			{
				"labID": "moonphase",
				"title": "Moon Phase Native App",
				"gridImg": "/images/home-workgrid/moonphase-sq.jpg",
				"icon": "/images/martian-logo.png",
				"client": "Martian",
				"launch": "Dec 2016",
				"projectColor": "D94C02",
				"pageHero": {
					"mediaType": "img",
					"src": "/images/moonphase-hero-1.jpg",
					"copy": "Building a native iPhone app using React Native",
					"headerOverlayOpacity": ".6"
				},
				"pageContent": [
					{
						"type": "sectionHeader",
						"number": "01",
						"title": "Challenge"
					},
					{
						"type": "intro",
						"intro": "<p>We love React and wanted to explore React Native, a promising platform allowing native app creation via Javascript using React.</p>",
						"logo": "/images/martian-logo.png"
					},
					{
						"type": "sectionHeader",
						"number": "02",
						"title": "Solution"
					},
					{
						"type": "textColumns",
						"copyLeft": "<p>React Native was very easy to approach; we had the app built out in just a few days.</p><p>The trickiest part was actually getting it submitted to the App Store! That process took much longer than actually developing the app.</p>",
						"copyRight": "<p>There are some tricks to getting React Native to work properly, and it's still limited in terms of functionality; it wouldn't be ideal for some situations.</p><p>That said, we were happy with how straightforward the process was, and plan to build more native apps soon.</p>"
					},
					{
						"type": "image",
						"size": "lg",
						"images": [
							{
								"title": "Image title",
								"src": "/images/moonphase-full-1.png"
							},
							{
								"title": "Image title",
								"src": "/images/moonphase-full-2.png"
							}
						]
					},
					{
						"type": "details",
						"siteurlLinkTitle": "Visit the Site",
						"siteurl": "https://appsto.re/us/uaXcgb.i",
						"list1Title": "What We Did",
						"list1": [
							{
								"title": "Concepting"
							},
							{
								"title": "UX"
							},
							{
								"title": "Prototyping"
							},
							{
								"title": "Design"
							},
							{
								"title": "Front-end Development"
							}
						],
						"list2Title": "Technologies",
						"list2": [
							{
								"title": ""
							},
							{
								"title": ""
							},
							{
								"title": ""
							}
						]
					}
				]
			},
			{
				"labID": "serenade",
				"title": "Serenade",
				"gridImg": "/images/home-workgrid/serenade-sq.jpg",
				"icon": "/images/martian-logo.png",
				"client": "Martian",
				"launch": "July 2016",
				"projectColor": "645C50",
				"pageHero": {
					"mediaType": "img",
					"src": "/images/serenade-hero-1.jpg",
					"copy": "Real-time interaction with hardware over the web.",
					"headerOverlayOpacity": ".6"
				},
				"pageContent": [
					{
						"type": "sectionHeader",
						"number": "01",
						"title": "Challenge"
					},
					{
						"type": "intro",
						"intro": "<p>We wanted to explore latency with hardare using sockets over the web; the idea was to create a virtual 'piano' that could be played by anyone, anywhere.</p>",
						"logo": "/images/martian-logo.png"
					},
					{
						"type": "sectionHeader",
						"number": "02",
						"title": "Solution"
					},
					{
						"type": "textColumns",
						"copyLeft": "<p>We designed an abstract set of 'piano keys', or objects that would be assigned to unique notes. We built the front-end with threeJS; the notes can be triggered with mouse, keyboard, or touch events. </p><p>We served the site off of a RaspberryPi from our office; the Pi also generated the notes. We tethered an Arduino and a strip of RGB LEDS each assigned to a note.</p>",
						"copyRight": "<p>This works over any connection to the web; there's almost zero-latency! It's pretty awesome.</p><p> While ultimately not a very useful tool, this was a fun project to prototype out.</p><p>Feel free to visit now and accompany us in our office while we work!</p>"
					},
					{
						"type": "image",
						"size": "full",
						"images": [
							{
								"title": "Image title",
								"src": "/images/serenade-full-1.png"
							},
							{
								"title": "Image title",
								"src": "/images/serenade-full-2.png"
							}
						]
					},
					{
						"type": "details",
						"siteurlLinkTitle": "Visit the Site",
						"siteurl": "http://serenade.martiansf.com",
						"list1Title": "What We Did",
						"list1": [
							{
								"title": "Concepting"
							},
							{
								"title": "UX"
							},
							{
								"title": "Prototyping"
							},
							{
								"title": "Design"
							},
							{
								"title": "Front-end Development"
							},
							{
								"title": "Backend Development"
							}
						],
						"list2Title": "Technologies",
						"list2": [
							{
								"title": ""
							},
							{
								"title": ""
							},
							{
								"title": ""
							}
						]
					}
				]
			}
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/data/labs.json
 ** module id = 223
 ** module chunks = 0
 **/